// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"6f91e887","921":"35fc010e"}[chunkId] + ".chunk.js";
};